import type { ColorScheme } from '@unifyapps/defs/types/interface';
import { UAModules } from '@unifyapps/defs/types/modules';
import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useUserPreferenceMutation } from '../../../../../../hooks/useUserPreferenceMutation';
import { COLOR_SCHEME_USER_PREFERENCE_KEY } from '../../../../../const';
import { useGlobalAppStateStore } from '../../../../../stores/app/GlobalAppStateStore';

export function useUpdateColorSchemeForPrivateInterface() {
  const { setUserPreference } = useUserPreferenceMutation();
  const interfaceId = useGlobalAppStateStore().hooks.record.useId();

  const updateColorSchemeForPrivateInterface = useEventCallback((colorScheme: ColorScheme) => {
    setUserPreference({
      applicationId: interfaceId,
      module: UAModules.INTERFACE,
      recordId: interfaceId,
      key: COLOR_SCHEME_USER_PREFERENCE_KEY,
      value: colorScheme,
    });
  });

  return { updateColorSchemeForPrivateInterface };
}
